import { useState } from 'react';
import { pageImageSrc, TOTAL_PAGES } from '@/lib/book';

interface BookPageImageProps {
  page: number;
  className?: string;
  imgClassName?: string;
}

export default function BookPageImage({ page, className = '', imgClassName = '' }: BookPageImageProps) {
  const [failed, setFailed] = useState(false);
  const n = Math.min(Math.max(Math.round(page), 1), TOTAL_PAGES);

  return (
    <div
      className={`relative overflow-hidden bg-background-50 ${className}`}
      style={{ aspectRatio: '210 / 297' }}
    >
      {failed ? (
        <div className="flex h-full w-full flex-col items-center justify-center gap-2 px-4 text-center text-secondary-500">
          <span className="flex h-12 w-12 items-center justify-center">
            <i className="ri-image-line text-3xl" aria-hidden="true"></i>
          </span>
          <span className="font-label text-sm leading-relaxed">
            이미지를 불러오는 중 문제가 발생했습니다 ({n}쪽)
          </span>
        </div>
      ) : (
        <img
          src={pageImageSrc(n)}
          alt={`${n}쪽`}
          className={`h-full w-full object-contain ${imgClassName}`}
          onError={() => setFailed(true)}
          draggable={false}
        />
      )}
    </div>
  );
}